<template>
	<view class="float_layer_content" v-show="loadStatus!=='hide'">
		<view class="window_load_box">
			<view ref="windowLoadPross" class="window_load_pross"></view>
		</view>
	</view>
</template>
<script setup>
	import {ref,defineExpose} from 'vue'
  import {createRandomNum} from "../common/js/comjs.js";

	const loadStatus = ref('hide');
	let floatLayerTimer = ref('');
	let floatLayersetTimer = ref('');
	let widthCount = ref(0);
	let windowLoadPross = ref(null);

  /**
   * 处理进度
   * @param status
   */
	function toggleFloat(status) {
		loadStatus.value = status;
		if(status === 'load'){
			floatLayerTimer.value?clearInterval(floatLayerTimer.value):'';
			floatLayerTimer.value = setInterval(() => {
				widthCount.value += createRandomNum('number',1,10);
				if (widthCount.value >= 98) {
					clearInterval(floatLayerTimer.value);
          widthCount.value = 98;
				}
				if(windowLoadPross.value !== null){
          windowLoadPross.value.style.width = widthCount.value+'%';
        }
			}, 300);
		}else{
			floatLayerTimer.value?clearInterval(floatLayerTimer.value):'';
			if(windowLoadPross.value !== null){
        windowLoadPross.value.style.width = '100%';
      }
			floatLayersetTimer.value?clearTimeout(floatLayersetTimer.value):'';
			setTimeout(()=>{
				loadStatus.value = 'hide';
			},500)
		}
	}
	defineExpose({toggleFloat});
</script>

<style>
	.window_load_box {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 1px;
		background: #c5c5cc;
		z-index: 99998;
		border-radius: 1px;
	}

	.window_load_pross {
		position: absolute;
		top: 0;
		left: 0;
		border-radius: 1px;
		height: 100%;
		width: 30px;
		background: #0270f8;
		z-index: 99999;
	}
</style>
